import React, { CSSProperties } from "react";
import SpinUI from "../Spin";
import ResultUI from "../Result";
import EmptyUI from "../Empty";
import { isLoadingDataEmpty } from "../loadingStateData";
import "./loadingUI.less";

type Props = {
  isLoading?: boolean;
  error?: any;
  dataList?: any;
  retryFunc?: () => void;
  children?: any;
  animationCls?: any;
  btnText?: any;
  errorText?: any;
  className?: string;
  style?: CSSProperties;
};

export default function LoadingUI(pros: Props) {
  const {
    isLoading,
    error,
    dataList,
    retryFunc,
    children,
    animationCls,
    btnText,
    errorText,
    className,
    style,
  } = pros;

  // 处理错误信息
  const getErrorInfo = () => {
    if (!error) return null;

    // 如果有自定义错误文本，直接使用
    if (errorText) {
      return { errorText, errorCode: error?.code };
    }

    // 处理不同类型的错误
    let finalErrorCode = error?.code;
    let finalErrorText = null;

    // 如果是网络错误或没有错误代码
    if (!finalErrorCode) {
      if (error?.message?.includes("timeout")) {
        finalErrorCode = "ERROR_TIMEOUT";
        finalErrorText = "Request timeout. Please try again.";
      } else if (error?.message?.includes("Network Error")) {
        finalErrorCode = "ERROR_NETWORK";
        finalErrorText = "Network error. Please check your connection.";
      } else {
        finalErrorCode = "ERROR_999";
        finalErrorText = "An unexpected error occurred. Please try again.";
      }
    }

    return { errorCode: finalErrorCode, errorText: finalErrorText };
  };

  return (
    <>
      {isLoading && (
        <div
          className={[animationCls, className, "web-loading-state-ui"]
            .filter(Boolean)
            .join(" ")}
          style={style}
        >
          <SpinUI dot block loading={true} />
        </div>
      )}
      {!isLoading && error && (
        <div
          className={[className, "web-loading-state-ui"]
            .filter(Boolean)
            .join(" ")}
          style={style}
        >
          <ResultUI
            status="error"
            errorCode={getErrorInfo()?.errorCode}
            errorText={getErrorInfo()?.errorText}
            retryFunc={retryFunc}
            btnText={btnText}
          />
        </div>
      )}
      {!isLoading && !error && isLoadingDataEmpty(dataList) ? (
        <div
          className={[className, "web-loading-state-ui"]
            .filter(Boolean)
            .join(" ")}
          style={style}
        >
          <EmptyUI showIcon={false} description={"NoData"} />
        </div>
      ) : (
        !isLoading && !error && children
      )}
    </>
  );
}
